"use client";

import { useAtomValue } from "jotai";
import React, { type ReactElement } from "react";
import {
  SitesMapLayerGeometry,
  SitesMapLayerTheme,
  SitesSitePopup,
} from "@/components";
import {
  selectedSiteAtom,
  siteObservatoryAtom,
  earthSitesAtom,
  biodiversitySitesAtom,
  universeSitesAtom,
  waterSitesAtom,
  themeVisibilityAtom,
} from "@/store/sites";
import { ThemeTypeEnum } from "@/types";

function SitesMapLayerList(): ReactElement {
  const selectedSite = useAtomValue(selectedSiteAtom);
  const siteObservatory = useAtomValue(siteObservatoryAtom);
  const earthSites = useAtomValue(earthSitesAtom);
  const waterSites = useAtomValue(waterSitesAtom);
  const universeSites = useAtomValue(universeSitesAtom);
  const biodiversitySites = useAtomValue(biodiversitySitesAtom);
  const themeVisibility = useAtomValue(themeVisibilityAtom);

  return (
    <>
      {selectedSite ? (
        <SitesSitePopup site={selectedSite} observatory={siteObservatory} />
      ) : null}
      {themeVisibility[ThemeTypeEnum.EARTH] ? (
        <SitesMapLayerTheme sites={earthSites} theme={ThemeTypeEnum.EARTH} />
      ) : null}
      {themeVisibility[ThemeTypeEnum.WATER] ? (
        <SitesMapLayerTheme sites={waterSites} theme={ThemeTypeEnum.WATER} />
      ) : null}
      {themeVisibility[ThemeTypeEnum.UNIVERSE] ? (
        <SitesMapLayerTheme
          sites={universeSites}
          theme={ThemeTypeEnum.UNIVERSE}
        />
      ) : null}
      {themeVisibility[ThemeTypeEnum.BIODIVERSITY] ? (
        <SitesMapLayerTheme
          sites={biodiversitySites}
          theme={ThemeTypeEnum.BIODIVERSITY}
        />
      ) : null}
      {selectedSite?.geometry ? (
        <SitesMapLayerGeometry site={selectedSite} />
      ) : null}
    </>
  );
}

export { SitesMapLayerList };
